import { initLayout } from '../layout.js';

document.addEventListener('DOMContentLoaded', () => {
    initLayout();
    setPaddingTop();
    window.addEventListener('resize', debounce(setPaddingTop, 200));
})

function setPaddingTop(){
    const headerHeight = document.querySelector('.custom-navbar').offsetHeight;
    document.querySelector('.privacy-policy').style.paddingTop = `${headerHeight}px`;
}

function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}
